// This file is auto-generated by @hey-api/openapi-ts

import { client } from "./client.gen";
import type { Client, Options as Options2, TDataShape } from "./client";
import type {
  CustomInputsCustomInputsPostData,
  CustomInputsCustomInputsPostErrors,
  CustomInputsCustomInputsPostResponses,
  GetAvailableMultiModalModelVersionMultiModalModelVersionsGetData,
  GetAvailableMultiModalModelVersionMultiModalModelVersionsGetErrors,
  GetAvailableMultiModalModelVersionMultiModalModelVersionsGetResponses,
  GetModelDescriptionModelDescriptionGetData,
  GetModelDescriptionModelDescriptionGetErrors,
  GetModelDescriptionModelDescriptionGetResponses,
  GetModelVersionModelVersionGetData,
  GetModelVersionModelVersionGetErrors,
  GetModelVersionModelVersionGetResponses,
  GetModelVersionRegistryModelVersionRegistryGetData,
  GetModelVersionRegistryModelVersionRegistryGetErrors,
  GetModelVersionRegistryModelVersionRegistryGetResponses,
  GetMultiModalModelCardMultiModalModelCardGetData,
  GetMultiModalModelCardMultiModalModelCardGetErrors,
  GetMultiModalModelCardMultiModalModelCardGetResponses,
  HealthHealthGetData,
  HealthHealthGetResponses,
  PredictFromDrawingPredictFromDrawingPostData,
  PredictFromDrawingPredictFromDrawingPostErrors,
  PredictFromDrawingPredictFromDrawingPostResponses,
  PredictMultiModalPredictMultiModalPostData,
  PredictMultiModalPredictMultiModalPostErrors,
  PredictMultiModalPredictMultiModalPostResponses,
  PredictPredictPostData,
  PredictPredictPostResponses,
  PredictV2BatchPredictV2BatchPostData,
  PredictV2BatchPredictV2BatchPostErrors,
  PredictV2BatchPredictV2BatchPostResponses,
  PredictV2PredictV2PostData,
  PredictV2PredictV2PostErrors,
  PredictV2PredictV2PostResponses,
  UpdateModelWeightsUpdateModelWeightsPostData,
  UpdateModelWeightsUpdateModelWeightsPostResponses,
} from "./types.gen";

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean,
  TResponse = unknown,
> = Options2<TData, ThrowOnError, TResponse> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>;
};

/**
 * Health
 *
 * Health check endpoint
 */
export const healthHealthGet = <ThrowOnError extends boolean = false>(
  options?: Options<HealthHealthGetData, ThrowOnError>,
) =>
  (options?.client ?? client).get<HealthHealthGetResponses, unknown, ThrowOnError>({
    url: "/health",
    ...options,
  });

/**
 * Predict
 *
 * Placeholder endpoint for compatibility
 */
export const predictPredictPost = <ThrowOnError extends boolean = false>(
  options?: Options<PredictPredictPostData, ThrowOnError>,
) =>
  (options?.client ?? client).post<PredictPredictPostResponses, unknown, ThrowOnError>({
    url: "/predict",
    ...options,
  });

/**
 * Predict V2
 *
 * Predicts the duration of processes in a given graph embedding
 */
export const predictV2PredictV2Post = <ThrowOnError extends boolean = false>(
  options: Options<PredictV2PredictV2PostData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PredictV2PredictV2PostResponses,
    PredictV2PredictV2PostErrors,
    ThrowOnError
  >({
    url: "/predict_v2",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Predict Multi Modal
 *
 * Predicts the duration of processes in a given graph embedding
 */
export const predictMultiModalPredictMultiModalPost = <ThrowOnError extends boolean = false>(
  options: Options<PredictMultiModalPredictMultiModalPostData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PredictMultiModalPredictMultiModalPostResponses,
    PredictMultiModalPredictMultiModalPostErrors,
    ThrowOnError
  >({
    url: "/predict_multi_modal",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Predict V2 Batch
 *
 * Batch prediction of the duration of processes in a given graph embedding
 */
export const predictV2BatchPredictV2BatchPost = <ThrowOnError extends boolean = false>(
  options: Options<PredictV2BatchPredictV2BatchPostData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PredictV2BatchPredictV2BatchPostResponses,
    PredictV2BatchPredictV2BatchPostErrors,
    ThrowOnError
  >({
    url: "/predict_v2_batch",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Predict From Drawing
 *
 * Predict cost from technical drawing extracted features
 */
export const predictFromDrawingPredictFromDrawingPost = <ThrowOnError extends boolean = false>(
  options: Options<PredictFromDrawingPredictFromDrawingPostData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PredictFromDrawingPredictFromDrawingPostResponses,
    PredictFromDrawingPredictFromDrawingPostErrors,
    ThrowOnError
  >({
    url: "/predict_from_drawing",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Available Multi Modal Model Version
 *
 * Get model version information
 */
export const getAvailableMultiModalModelVersionMultiModalModelVersionsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAvailableMultiModalModelVersionMultiModalModelVersionsGetData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAvailableMultiModalModelVersionMultiModalModelVersionsGetResponses,
    GetAvailableMultiModalModelVersionMultiModalModelVersionsGetErrors,
    ThrowOnError
  >({ url: "/multi-modal_model-versions", ...options });

/**
 * Get Multi Modal Model Card
 *
 * Get model version information
 */
export const getMultiModalModelCardMultiModalModelCardGet = <ThrowOnError extends boolean = false>(
  options: Options<GetMultiModalModelCardMultiModalModelCardGetData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetMultiModalModelCardMultiModalModelCardGetResponses,
    GetMultiModalModelCardMultiModalModelCardGetErrors,
    ThrowOnError
  >({ url: "/multi-modal_model-card", ...options });

/**
 * Get Model Version
 *
 * Get model version information
 */
export const getModelVersionModelVersionGet = <ThrowOnError extends boolean = false>(
  options?: Options<GetModelVersionModelVersionGetData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    GetModelVersionModelVersionGetResponses,
    GetModelVersionModelVersionGetErrors,
    ThrowOnError
  >({ url: "/model-version", ...options });

/**
 * Get Model Version Registry
 *
 * Get model version information
 */
export const getModelVersionRegistryModelVersionRegistryGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetModelVersionRegistryModelVersionRegistryGetData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    GetModelVersionRegistryModelVersionRegistryGetResponses,
    GetModelVersionRegistryModelVersionRegistryGetErrors,
    ThrowOnError
  >({ url: "/model-version-registry", ...options });

/**
 * Get Model Description
 *
 * Get model version information
 */
export const getModelDescriptionModelDescriptionGet = <ThrowOnError extends boolean = false>(
  options?: Options<GetModelDescriptionModelDescriptionGetData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    GetModelDescriptionModelDescriptionGetResponses,
    GetModelDescriptionModelDescriptionGetErrors,
    ThrowOnError
  >({ url: "/model-description", ...options });

/**
 * Update Model Weights
 *
 * Update model weights
 */
export const updateModelWeightsUpdateModelWeightsPost = <ThrowOnError extends boolean = false>(
  options?: Options<UpdateModelWeightsUpdateModelWeightsPostData, ThrowOnError>,
) =>
  (options?.client ?? client).post<
    UpdateModelWeightsUpdateModelWeightsPostResponses,
    unknown,
    ThrowOnError
  >({ url: "/update_model_weights", ...options });

/**
 * Custom Inputs
 *
 * Get custom input configuration
 */
export const customInputsCustomInputsPost = <ThrowOnError extends boolean = false>(
  options: Options<CustomInputsCustomInputsPostData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    CustomInputsCustomInputsPostResponses,
    CustomInputsCustomInputsPostErrors,
    ThrowOnError
  >({
    url: "/custom_inputs",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
